(() => {
  if (window.LSHomeImageSlider) {
    window.LSHomeImageSlider.initialize();
    return;
  }

  const interval = 5000;
  const controllers = new Set();

  const initialize = (root = document) => {
    root.querySelectorAll('[data-home-image-slider]').forEach((slider) => {
      if (slider.dataset.homeImageSliderInitialized === 'true') return;
      slider.dataset.homeImageSliderInitialized = 'true';

      const slides = [...slider.children].filter((element) => element.tagName === 'IMG');
      const dots = [...slider.querySelectorAll('[data-home-image-index]')];
      const nextButton = slider.querySelector('[data-home-image-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer;

      if (slides.length < 2) return;

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === current));
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-pressed', String(active));
        });
      };

      const stop = () => {
        window.clearTimeout(timer);
        timer = undefined;
      };

      const start = () => {
        stop();
        if (!reducedMotion && !document.hidden && slider.isConnected) {
          timer = window.setTimeout(() => {
            show(current + 1);
            start();
          }, interval);
        }
      };

      const select = (index) => {
        show(index);
        start();
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => select(Number(dot.dataset.homeImageIndex)));
      });
      nextButton?.addEventListener('click', () => select(current + 1));
      slider.addEventListener('click', (event) => {
        if (!event.target.closest('button')) select(current + 1);
      });

      const controller = { slider, start, stop };
      controllers.add(controller);
      start();
    });
  };

  window.LSHomeImageSlider = { initialize };

  document.addEventListener('visibilitychange', () => {
    controllers.forEach((controller) => {
      if (controller.slider.isConnected) controller.start();
      else {
        controller.stop();
        controllers.delete(controller);
      }
    });
  });
  window.addEventListener('pageshow', () => controllers.forEach((controller) => controller.start()));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', () => {
    controllers.forEach((controller) => {
      if (!controller.slider.isConnected) {
        controller.stop();
        controllers.delete(controller);
      }
    });
  });

  initialize();
})();
